import { render, staticRenderFns } from "./UpdateProgramsModal.vue?vue&type=template&id=6952df66&"
import script from "./UpdateProgramsModal.vue?vue&type=script&lang=js&"
export * from "./UpdateProgramsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports